import { RQ, getRouteUrl, isWechat, isIOS } from 'utils';
import { share } from 'utils/wx';
import config from 'config';
import { addClickAnalytics } from 'utils/analytics';

export default {
  getInfo: async function () {
    if (!this.inviteCode) return;

    const d = await RQ.mall.get(
      '/api/b/user/auth/getInviteCodeInfo',
      {
        inviteCode: this.inviteCode
      },
      { enterprise: '00' }
    );
    if (d && d.code == 0) {
      this.refereesInfo = d.data;
      this.enterprise = d.data.enterpriseNo;
      G.enterprise = d.data.enterpriseNo;

      this.pageTitle = `${d.data.name}邀请您成为TA的会员`;
      console.log('d.data', d.data);

      this.addShare(this.inviteCode, d.data.enterpriseName, d.data.name);
    } else {
      this.tips(d.msg, 1500);
    }
  },

  sendMsgCode: async function () {
    addClickAnalytics({ LogTitle: '获取短信验证码' });
    var self = this;
    if (self.phone.length == 11) {
      if (self.isGetting) {
        self.tips('不能同时发送语音与短信验证码');
        return;
      }
      const d = await RQ.mall.get(
        '/api/h5/user/auth/getValidateCode',
        {
          phone: self.phone,
          purpose: 1,
          inviteCode: self.inviteCode
        },
        { enterprise: '00' }
      );

      if (d && d.code == 0) {
        // console.log('验证码~~~~',d)
        self.sendBtnShow = true;
        self.isGetting = true;
        var clock = setInterval(function () {
          self.nums--;
          if (self.nums > 0) {
            // self.sendCodeText = '重新获取 ' + nums + 's';
          } else {
            clearInterval(clock); // 清除js定时器
            console.log(self.nums);
            self.sendBtnShow = false;
            self.isGetting = false;
            self.speechViewShow = true;
            self.sendCodeText = '重发验证码';
            self.nums = 60; // 重置时间
          }
        }, 1000); // 一秒执行一次
      } else {
        self.tips(d.msg);
      }
    } else {
      if (self.phone.length == 0) {
        self.tips('请输入手机号', 2000);
      } else {
        self.tips('请输入正确的手机号', 2000);
      }
    }
  },
  sendSpeechDialog() {
    addClickAnalytics({ LogTitle: '获取语音验证码' });
    if (this.isGetting) {
      this.tips('不能同时发送语音与短信验证码');
      return;
    }
    this.showSpeechDialog = true;
  },
  sendSpeechCode: async function () {
    addClickAnalytics({ LogTitle: '确认接听语音验证码' });
    var self = this;
    if (self.phone.length == 11) {
      const d = await RQ.mall.get(
        '/api/h5/user/auth/getValidateCode',
        {
          phone: self.phone,
          purpose: 1,
          inviteCode: self.inviteCode,
          busi: 2
        },
        { enterprise: '00' }
      );

      if (d && d.code == 0) {
        console.log('语音验证码 ~~~~', d);
        self.speechBtnShow = true;
        self.isGetting = true;
        var clock = setInterval(function () {
          self.speechTime--;
          if (self.speechTime > 0) {
          } else {
            clearInterval(clock); // 清除js定时器
            console.log(self.speechTime);
            self.speechBtnShow = false;
            self.isGetting = false;
            self.speechViewShow = true;
            self.sendSpeechText = '重发语音';
            self.speechTime = 60; // 重置时间
          }
        }, 1000); // 一秒执行一次
      } else {
        self.tips(d.msg);
      }
    } else {
      if (self.phone.length == 0) {
        self.tips('请输入手机号', 2000);
      } else {
        self.tips('请输入正确的手机号', 2000);
      }
    }
  },
  confirmFn() {
    this.sendSpeechCode();
  },
  cancelFn() {
    addClickAnalytics({ LogTitle: '取消接听语音验证码' });
    this.showSpeechDialog = false;
  },
  submitBtn: async function () {
    addClickAnalytics({ LogTitle: '登录' });
    var self = this;
    var post = {};
    post.phone = self.phone;
    post.validateCode = self.authCode;
    post.inviteCode = self.inviteCode || self.refereesInfo.inviteCode;

    if (!post.phone) {
      self.tips('请输入手机号', 1500);
      return;
    }
    if (!self.authCode) {
      self.tips('请输入验证码', 1500);
      return;
    }

    const d = await RQ.mall.post('/api/h5/user/auth/login', post, {
      jsonBody: true,
      enterprise: '00'
    });
    if (d && d.code == 0) {
      G.member = d.data;
      localStorage.setItem(this.enterprise, JSON.stringify(G.member));
      // G.wxId = localStorage.getItem(this.enterprise + '_wxid');
      const route = {
        path: `/${this.enterprise}/login/result`,
        query: {
          inviteCode: this.inviteCode,
          // 微信中分享或者朋友圈会添加from参数，需要跟它区分一下
          // _from: this.params._from || 'login',
          // TODO 如果是使用APP登陆接口。没有这个返回值
          loginType: d.data.loginType,
          redirect: this.params.redirect || encodeURIComponent(location.href.replace(location.origin, ''))
        }
      };
      // if (!G.wxId && isWechat()) {
      //   const url = encodeURIComponent(window.location.origin + getRouteUrl(route.path, route.query))
      //   location.href = window.config.hosts.mall + `/${this.enterprise}/api/h5/wechat/snsapi_base?webUrl=${url}&isPlatform=${G.is_platform !== undefined ? G.is_platform : 0}`
      // } else {
      this.$router.push(route);
      // }
    } else {
      self.tips(d.msg, 1500);
    }
  },
  downLoadApp: async function () {
    addClickAnalytics({ LogTitle: '下载APP' });
    if (this.enterprise) {
      this.$router.push({ path: `/download?enterprise=${this.enterprise}` });
    } else {
      await this.getInfo();
      this.downLoadApp();
    }
  },
  addShare(inviteCode, enterpriseName, userName) {
    const shareData = {
      shareUrl: `${config.hosts.host}/wp/app/login?inviteCode=${inviteCode}&is_platform=${G.is_platform !== undefined ? G.is_platform : 0}`,
      shareTitle: `我在${enterpriseName}发现了很多不错的商品！`,
      shareImg: 'https://yolipaiapp-10000842.file.myqcloud.com/leadmall/share_icon.png',
      shareContent: '超值低价，快来看看吧！'
    };
    share(this.$route, {
      title: shareData.shareTitle,
      desc: shareData.shareContent,
      link: shareData.shareUrl,
      imgUrl: shareData.shareImg,
      type: 'link' // 分享类型,music、video或link，不填默认为link
    });
  }
};



// WEBPACK FOOTER //
// ./src/module/member/login/action.js